"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAY_ORDER_WITH_CARD_AXEPTA = void 0;
const client_1 = require("@apollo/client");
exports.PAY_ORDER_WITH_CARD_AXEPTA = client_1.gql `
  query payOrderWithCardAxepta($userRedirectUrl: String! $idOrder: String) {
    payOrderWithCardAxepta(userRedirectUrl: $userRedirectUrl idOrder: $idOrder) {
      _links {
        redirect {
          href
          type
        }
      }
    }
  }
`;
